import React, { ReactNode } from 'react';

import { Button, ButtonProps } from '@mantine/core';

import classes from './kiloButton.module.css';

export type KiloButtonVariant =
  | 'default'
  | 'flat'
  | 'revenueCategories'
  | 'revenueCategoriesGray'
  | 'kioskGrayNoUnderline'
  | 'KioskGrayDefault'
  | 'kioskAthleteModeDisabled';

type KiloButtonProps = ButtonProps & {
  rootVariantType?: KiloButtonVariant;
  children: ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const KiloButton = ({
  rootVariantType = 'default',
  children,
  classNames,
  ...rest
}: KiloButtonProps): JSX.Element => {
  const variantClassMap: Record<KiloButtonVariant, string> = {
    default: '',
    flat: classes.flat,
    revenueCategories: classes.revenueCategories,
    revenueCategoriesGray: classes.revenueCategoriesGray,
    KioskGrayDefault: classes.kioskGrayRoot,
    kioskGrayNoUnderline: classes.kioskGrayRoot,
    kioskAthleteModeDisabled: classes.kioskAthleteModeCheckedInRoot,
  };

  const innerClassMap: Record<KiloButtonVariant, string> = {
    default: '',
    flat: classes.flatInner,
    revenueCategories: '',
    revenueCategoriesGray: '',
    KioskGrayDefault: classes.kioskGrayInner,
    kioskGrayNoUnderline: classes.kioskGrayInnerNoUnderline,
    kioskAthleteModeDisabled: classes.kioskAthleteModeCheckedInInner,
  };

  return (
    <Button
      {...rest}
      classNames={{
        root: variantClassMap[rootVariantType],
        inner: innerClassMap[rootVariantType],
      }}
    >
      {children}
    </Button>
  );
};

export default KiloButton;
